import * as Sentry from '@sentry/react';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom';

import App from './App';
import DugoutApp from './DugoutApp';
import bootChromeExtensionVersion from './utils/bootChromeExtensionVersion';
import determineEnvFromLocation from './utils/determineEnvFromLocation';

import './index.css';

// Roboto is used in members facing pages like
// unified onboarding
import 'typeface-roboto';

const { VITE_APP_GIT_SHA } = process.env;

// Errors thrown in the extension's side panel are otherwise indistinguishable
// from the same error in the standalone app, and the extension rolls out
// gradually through the Web Store — without the version we can't tell which
// installs an issue affects.
const extensionVersion = bootChromeExtensionVersion;

Sentry.init({
  release: 'dugout@' + VITE_APP_GIT_SHA,
  environment: determineEnvFromLocation(),
  initialScope: {
    tags: {
      inChromeExtension: extensionVersion !== null,
      chromeExtensionVersion: extensionVersion ?? undefined
    }
  },
  dsn: 'https://7c210037a83b4b1b90484e6f7d6d1f59@o552385.ingest.sentry.io/4504976221601792',
  beforeSend(event) {
    // NOTE: zoom throws a log of bening errors internally. Showing the dialog in this
    // page is very disruptive.
    const isMeetingError = event.request?.url?.endsWith('/meeting');
    // Check if it is an exception, and if so, show the report dialog
    if (event.exception && !isMeetingError) {
      Sentry.showReportDialog({ eventId: event.event_id });
    }
    return event;
  },
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    })
  ],
  tracesSampleRate: 0,
  enabled: process.env.NODE_ENV !== 'development'
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    {window.location.href.includes('/members') ? <App /> : <DugoutApp />}
  </React.StrictMode>
);
